import { apiFetch } from "./client";
import type { RoleRef } from "./access";
import type { UserSummary } from "./auth";

/** `/api/dev/*` — exists only when the backend runs with profile `dev` (404 elsewhere). */
export type DevUser = {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  roles: RoleRef[];
};

export const devApi = {
  users: () => apiFetch<DevUser[]>("/dev/users"),
  switchUser: (id: string) => apiFetch<UserSummary>(`/dev/switch-user/${id}`, { method: "POST" }),
};
